import Webcam from 'react-webcam';
import React, { forwardRef, useEffect } from 'react';



export const WebCamComponent = forwardRef((props,  ref) => {
    const { onElementClick, ...rest} = props;

    useEffect(() => {
        const timer = setInterval(() => {
            if (ref.current) {
                const img = ref.current.getScreenshot();
                if (img) {
                    onElementClick(false);
                    clearInterval(timer);
                }
            }
        }, 1000);
    
        return () => clearInterval(timer);
    }, [ref.current]);
    
    return (
        <Webcam 
            ref={ref}
            { ...rest }
        />
    )
})
